import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useZervantSubscriptionDetails } from '@features/zervant-subscription/hooks/useZervantSubscriptionDetails'
import { SubscriptionPeriod } from '@modules-deprecated/app/organization/enums/subscriptionPeriod'
import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'
import {
  notifySubscriptionUpdateError,
  notifySubscriptionUpdateSuccess,
} from '@views/settings/routes/OrganizationSubscriptionSettings/utils'

import { useOrganizationUiSetup } from '../../../hooks/useOrganizationUiSetup'
import type { BackToSchoolCheckoutParams } from '../types/backToSchoolCheckoutParams'

export const useBackToSchoolOfferCheckout = (onEditSubscription: (params: BackToSchoolCheckoutParams) => void) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { t } = useTranslation()
  const { isUiSetupShineInvoicingAccounting } = useOrganizationUiSetup()
  const { isInZervantNoPlan } = useZervantSubscriptionDetails()

  const shouldForceExternal = isUiSetupShineInvoicingAccounting && isInZervantNoPlan

  const openCheckout = useCallback(
    (plan: SubscriptionPlan, promoPriceAmount: number, coupon: string): void => {
      setIsSubmitting(true)
      onEditSubscription({
        detail: {
          callback: (error) => {
            if (error) {
              setIsSubmitting(false)
              notifySubscriptionUpdateError(t, error.message)
              return
            }

            notifySubscriptionUpdateSuccess(t)
          },
          coupon,
          forceExternal: shouldForceExternal,
          period: SubscriptionPeriod.Yearly,
          plan,
          price: promoPriceAmount,
        },
      })
    },
    [onEditSubscription, shouldForceExternal, t],
  )

  return { isSubmitting, openCheckout }
}
